export function createXPositionGetter(viewPortWidth: number, columnWidth: number, columnCount: number) {
  return (index: number) => viewPortWidth - (columnCount - index) * columnWidth;
}
